import { useCallback, useMemo } from 'react';

import type { FiltersInterface } from '@app/pages/Analytics/types';
import { getShownReportPeriod } from '@app/pages/Analytics/utils';
import { useHeader } from '@app/providers';

// Период, за который во вкладке отчёта сейчас показана таблица. Хранится в
// HeaderContext отдельно для каждой вкладки, чтобы экспорт в Excel брал
// период показанной таблицы, а не последний «Показать» в любой вкладке или
// несохранённые значения селектов (issue/11357).
export const useShownReportPeriod = (tabKey: string) => {
  const { header, setHeader } = useHeader();

  const shownPeriod = useMemo(
    () => getShownReportPeriod(header, tabKey),
    [header, tabKey]
  );

  const setShownPeriod = useCallback(
    ({ filterMonth, filterYear }: FiltersInterface) => {
      setHeader((prev) => ({
        ...prev,
        [tabKey]: { filterMonth, filterYear },
      }));
    },
    [setHeader, tabKey]
  );

  return { shownPeriod, setShownPeriod };
};
